import * as types from '../constants/ActionTypes'
import {handleActions} from 'redux-actions'
import {updateArrayItem} from '../utils/helpers'
const reducers = {}
const initialState = {
    list: [],
    queryList: [],
    pageIndex:1,
    pageSize:10,
    count:0
}


reducers[types.GET_AGENTLIST] = (state, action) => {
	return Object.assign({}, state, {isLoading: true, isLoaded: false, loadError: false})
}

reducers[types.GET_AGENTLIST_FINISH] = {
	next(state, action) {
		let agentList = action.payload.agents.map(agent => Object.assign({}, agent, {unreadChatCount: 0}))

		return Object.assign({}, state, {
			list: agentList,
			isLoading: false,
			isLoaded: true
		})
	},
	throw(state) {
		return Object.assign({}, state, {isLoading: false, loadError: true})
	}
}

reducers[types.UPDATE_AGENT_LOGIN_STATE] = {
        next(state = initialState, action) {
                let agentList = state.list.map(agent => {
                        if (agent.fullUserId === action.payload.fullUserId)
                                agent.isLoggedIn = action.payload.online

                        return agent
                })
                return Object.assign({}, state, {list: agentList})
        }
}

reducers[types.UPDATE_AGENT_SERVICE_STATUS] = {
    next(state = initialState, action) {
        let agentList = state.list.map(agent => {
            if (agent._id === action.payload.agentId)
                agent.isServiceOn = action.payload.service
            return agent
        })
        return Object.assign({}, state, {list: agentList})
    }
}

reducers[types.SET_AGENT_CHAT_COUNT] = {
	next(state = initialState, action) {
		let agentList = state.list.map(agent => {
			if (agent.fullUserId === action.payload.senderFullUserId)
				agent.unreadChatCount++

			return agent
		})
		return Object.assign({}, state, {list: agentList})
	}
}

reducers[types.CHANGE_SELECTED_AGENT] = {
	next(state = initialState, action) {
		let agentList = state.list.map(agent => {
			if (agent.fullUserId === action.payload.agentFullUserId)
				agent.unreadChatCount = 0

			return agent
		})
		return Object.assign({}, state, {list: agentList})
	}
}
reducers[types.QUERY_AGENTS_BYPAGE_FINISH] = {
    next(state, action){
        return Object.assign({}, state, {
            queryList: action.payload.queryList,
            isAgentLogin:action.payload.isAgentLogin,
            count:action.payload.count,
            pageIndex:action.payload.pageIndex,
            pageSize:action.payload.pageSize
        })
    },
    throw(state){
        return Object.assign({}, state, {loadError: true})
    }
}

reducers[types.CREATE_AGENT_INITIATE]=(state,action)=>{
	return Object.assign({},state,{isCreateing:true,isCreated:false,createError:false})
}
reducers[types.CREATE_AGENT_FINISH] = {
    next(state, action){
        return Object.assign({}, state, {isCreating: false, isCreated: true, createError: false})
    },
    throw(state){
        return Object.assign({}, state, {isCreating: false, isCreated: true, createError: true})
    }

}

reducers[types.DELETE_ACCOUNT_FINISH]=(state,action)=>{
    return Object.assign({},state,{isDeleting:false,isDeleted:true,createError:false})
}
reducers[types.UPDATE_ACCOUNT_AVATAR_FINISH]=(state,action)=>{
    return Object.assign({},state,{isUpdating:false,isUpdated:true,updateError:false})
}
export default handleActions(reducers, initialState)
